<template>
    <span>
        <span v-if="isRequired" :class="{ invalid: !isValid }">
            *<sup>{{ $t("required") }}</sup>
        </span>
        <!-- required: {{isRequired}} valid: {{isValid}} -->
    </span>
</template>

<script>
export default {
    props: {
        isRequired: {
            type: Boolean,
            default: true
        },
        isValid: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
span.invalid {
    color: red;
}
sup {
    font-size: 66%;
}
</style>
